import { Stack, Typography } from '@mui/material';
import { AddressApiResponse } from '@src/lib/__generated/api';
interface AddressBlockProps {
  address: AddressApiResponse | undefined;
  zipCode: string | null | undefined;
}
export default function AddressBlock({
  address,
  zipCode
}: AddressBlockProps) {
  return <>
			{address && <Stack alignItems="start" aria-details="address">
					<Typography color="text.secondary" variant="bodyMediumBook">
						{address.line1}
					</Typography>
					<Typography color="text.secondary" variant="bodyMediumBook">
						{address.city}, {address.state} {zipCode}
					</Typography>
				</Stack>}
		</>;
}